import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-password-check',
  templateUrl: './password-check.component.html',
  styleUrls: ['./password-check.component.scss']
})
export class PasswordCheckComponent implements OnInit {

  @Input() password: string;
  @Output() passActive = new EventEmitter<boolean>();
  
  color = '#f25a5a';
  
  eight_char = this.color;
  lowercase = this.color;
  uppercase = this.color;
  special_char = this.color;
  number = this.color;

  // valid = true;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {  
    // this.passActive.emit(true);
      let string  = this.password ?? "";
      let uppercase = false, lowercase = false, number = false, eight = false, special_char = false;
      var letters = /^[A-Za-z]+$/;
  
      for(let i=0; i< string.length; i++){
        if(string[i].match(letters) && string[i] == string[i].toUpperCase() ){
          uppercase = true;
        }
        if(string[i].match(letters) && string[i] == string[i].toLowerCase() ){
          lowercase = true;
        }
        if(parseInt(string[i]) >= 0 && parseInt(string[i]) <= 9){
          number = true;
          
        }
        if(parseInt(string[i]) >= 0 && parseInt(string[i]) <= 9){
          number = true;
          
        }
      }
  
      if(string.length >= 8){
        this.eight_char = "black";   
        eight = true;
      } else{
        this.eight_char = this.color;   

      }
  
      if(uppercase){
        this.uppercase = 'black';
      }else{
        this.uppercase = this.color;
      }
  
      if(lowercase){
        this.lowercase = 'black';
      }else{
        this.lowercase = this.color;
      }
  
      if(number){
        this.number = 'black';
      }else{
        this.number = this.color;
      }
  
      if(this.containsSpecialChars(string)){
        this.special_char = 'black';
        special_char = true;
      }else {
        this.special_char = this.color    
      }
  
      if(uppercase && lowercase && number && eight && special_char){
       this.passActive.emit(true);
      }else{
        this.passActive.emit(false);
      }
  }

  containsSpecialChars(str:any) {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(str);
  }

}
